import keyboardNumericInput from '@/components/keyboard-numeric-input/keyboard-numeric-input.vue';

export default {
  components: {
    keyboardNumericInput,
  },
  props: {
    title: {
      type: String,
      default: 'Minimum Sell Price',
    },
    value: {
      type: Number,
      default: 50,
    },
    kind: {
      type: String,
      default: 'modal',
    },
    selected: Boolean,
    userQuantity: {},
    threshold: {
      type: Number,
      default: 25,
    },
    operationType: {
      type: String,
      default: 'buy',
    },
    tabindex: Number,
    minimumOwnership: {
      type: Number,
      default: 1,
    },
    minValue: {
      type: Number,
      default: 1,
    },
    maxValue: {
      type: Number,
      default: 9999,
    },
  },
  data() {
    return {
      updated: false,
      val: this.value !== null ? parseInt(this.value, 10) : null,
    };
  },
  computed: {
    classModifier() {
      return {
        'purchase-quantity-value': true,
        [`purchase-quantity-value--${this.kind}`]: this.kind,
        'purchase-quantity-value--selected': this.selected,
      };
    },
  },
  watch: {
    val: 'updateOffer',
    value(value) {
      this.val = value !== null ? parseInt(value, 10) : null;
    },
  },
  methods: {
    add() {
      if (isNaN(this.val) || this.val === null || this.val === 1) {
        this.val = 0;
      }
      let newValue = this.val + this.threshold;
      if (
        this.userQuantity &&
        this.operationType === 'sell' &&
        this.val <= this.userQuantity &&
        newValue > this.userQuantity
      ) {
        newValue = this.userQuantity;
      }
      this.val = Math.min(newValue, this.maxValue);
    },
    subtract() {
      if (isNaN(this.val) || this.val === null || this.val < (this.threshold + 1)) {
        this.val = (this.threshold + 1);
      }
      let newValue = this.val - this.threshold;
      this.val = Math.max(newValue, this.minValue);
    },
    updateOffer() {
      this.updated = true;
      this.val = parseInt(this.val, 10);
      if (isNaN(this.val) || this.val < 1) this.val = null;

      if (this.val !== null) {
        this.$emit('input', Number(this.val));
      } else {
        this.$emit('input', this.val);
      }
    },
    click() {
      this.$emit('click');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/purchase-quantity-value/purchase-quantity-value.js